import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gantt_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// AI credit — every successful AI call changes the credit used, so the header badge
// and the account sheet refetch GET /ai/usage when this event fires.
export const AI_USAGE_EVENT = "flowgantt:ai-usage-changed";
const AI_CALL_URL = /(^|\/)ai(\/|-)/;

// Contextual paywall — dispatch a global event any component can subscribe to.
// Backend returns 402 with detail = {paywall_action, message} on blocking actions.
api.interceptors.response.use(
  (r) => {
    const { method, url } = r.config || {};
    if (method === "post" && AI_CALL_URL.test(url || "")) {
      window.dispatchEvent(new CustomEvent(AI_USAGE_EVENT));
    }
    return r;
  },
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 402 && detail && typeof detail === "object" && detail.paywall_action) {
      window.dispatchEvent(
        new CustomEvent("flowgantt:paywall", {
          detail: { action: detail.paywall_action, message: detail.message },
        }),
      );
    }
    return Promise.reject(err);
  },
);

export default api;
